module.exports = "<main>\n  <router-outlet></router-outlet>\n</main>\n"